import { Modal } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { PreviewStep } from './components/PreviewCard';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  completionDeadline: number;
  incompletePaymentsLimit: number;
};

export const ControlRulePreviewModal = ({
  isOpen,
  setIsOpen,
  completionDeadline,
  incompletePaymentsLimit,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title={t('setupHub.controlRules.preview.title')}
      iconName="circle-information"
    >
      <div className="flex flex-col items-center">
        <div className="mt-20 flex flex-col gap-8">
          <PreviewStep
            title={t('setupHub.controlRules.preview.missingReceipt.title', {
              count: completionDeadline - 1,
            })}
            description={t(
              'setupHub.controlRules.preview.missingReceipt.description',
            )}
          />
          <PreviewStep
            title={t('setupHub.controlRules.preview.lateReceipt.title', {
              count: completionDeadline,
            })}
            description={t(
              'setupHub.controlRules.preview.lateReceipt.description',
            )}
          />
          <PreviewStep
            title={t('setupHub.controlRules.preview.accessBlocked.title', {
              count: incompletePaymentsLimit || 1,
            })}
            description={t(
              'setupHub.controlRules.preview.accessBlocked.description',
            )}
          />
        </div>
        <a
          className="my-16 text-content-primary underline body-l"
          href="https://helpcenter.spendesk.com/articles/4240464"
          target="_blank"
          rel="noreferrer"
        >
          {t('misc.learnMore')}
        </a>
      </div>
    </Modal>
  );
};
